import {
    IContratoLancamento,
    IContratoLancamentoEmpresaResumo,
    IContratoLancamentoRequest,
    IDashboardContratoLancamento,
} from '../interfaces/IContratoLancamento';
import api from './Api';

class ContratoLancamentoService {
    async obterHistorico(clienteId: number): Promise<IContratoLancamento[]> {
        const { data: result } = await api.get<IContratoLancamento[]>(`ContratoLancamento/${clienteId}`);
        return result;
    }

    async obterDashboard(clienteId: number): Promise<IDashboardContratoLancamento> {
        const { data: result } = await api.get<IDashboardContratoLancamento>(`ContratoLancamento/${clienteId}/dashboard`);
        return result;
    }

    async criar(clienteId: number, request: IContratoLancamentoRequest): Promise<IContratoLancamento> {
        const { data: result } = await api.post<IContratoLancamento>(`ContratoLancamento/${clienteId}`, request);
        return result;
    }

    async editarQuantidadeEmpresa(clienteId: number, empresaId: number, quantidadeContratada: number): Promise<IContratoLancamentoEmpresaResumo> {
        const { data: result } = await api.put<IContratoLancamentoEmpresaResumo>(
            `ContratoLancamento/${clienteId}/empresa/${empresaId}`,
            { quantidadeContratada }
        );
        return result;
    }

    async cancelar(clienteId: number): Promise<void> {
        await api.delete(`ContratoLancamento/${clienteId}`);
    }
}

export default new ContratoLancamentoService();
